import React, { FC, useRef } from "react";
import { useOutsideClick } from "hooks/useOutsideClick";
//components
import { Row } from "components/Layout/Grid";
//assets
import RedStockIcon from 'img/redStockIcon.svg';
import BlueStockIcon from 'img/stockIcon.svg';
//models
import { ItemStockProps } from "models/Quote";
//styles
import "./styles.scss";

interface IQuoteStockInfo {
  stockInfo: any;
  saved?: boolean;
  showExtra?: boolean;
  setShowExtra?: any;
  mapProducts?: boolean;
}

const QuotesStockInfo: FC<IQuoteStockInfo> = ({
  saved,
  stockInfo,
  showExtra,
  mapProducts,
  setShowExtra
}) => {

  const wrapperRef = useRef(null);
  useOutsideClick(wrapperRef, setShowExtra);

  const stock = stockInfo?.filter((stockItem: ItemStockProps) => stockItem.stock > 0);
  const stockIcon = stock?.length > 0 ? BlueStockIcon : RedStockIcon;

  const openTooltip = () => {
    setShowExtra(!showExtra);
  };

  const extraBox = (
    <div className={`stock-column--extra-info ${mapProducts ? 'top-modal-stock' : ''}`}>
      <div className="stock-column--info-header">
        <span className="stock-column--stock-dc local">FILIAL</span>
        <span className="stock-column--stock-num">ESTOQUE</span>
        {saved === undefined && (<span className="stock-column--stock-num blocked">BLOQUEADO</span>)}
      </div>

      <div className="stock-column--info-content">
        {stockInfo !== undefined &&
          stockInfo?.map((item: any, num: number) => {
            return (
              <div key={`stock-opt-${item.local}`} className={`${item.stock == 0 ? 'stock-column--row-red' : 'stock-column--row-gray'}`}>
                <span className="stock-column--stock-dc local">{item.local}</span>

                <span className="stock-column--stock-num">{item.stock}</span>

                {saved === undefined && (
                  <span className="stock-column--stock-num blocked">{item.stockLocked}</span>
                )}
              </div>
            );
          })}
      </div>
    </div>
  );

  return (
    <Row className="quotes-stock-column">
      {stockInfo?.length > 0 && (
        <div ref={wrapperRef} onClick={openTooltip} className="stock-suggestion">
          <img src={stockIcon} alt="icon-stock-suggestion" />
        </div>
      )}
      {stockInfo?.length > 0 && showExtra && extraBox}
    </Row>
  );
};

export default QuotesStockInfo;
